import React, { useContext } from "react"
import Img from "gatsby-image"
import styled from "styled-components"

import ContentfulDataContext from "../context/contentful-data"

import { breakpoints } from "../parameters/theme"

const Container = styled.div`
  display: flex;
  flex-flow: row wrap;

  .image-container {
    padding: 5px;
    text-align: center;

    &.images-2 {
      flex-basis: 50%;
    }
    &.images-3 {
      flex-basis: 33.33%;
    }
    &.images-4 {
      flex-basis: 25%;
    }
    &.images-5 {
      flex-basis: 20%;
    }
    &.images-6 {
      flex-basis: 16.66%;
    }
    &.images-7 {
      flex-basis: 14.28%;
    }
    &.images-8 {
      flex-basis: 12.5%;
    }
    &.images-9 {
      flex-basis: 11.11%;
    }
    &.images-10 {
      flex-basis: 10%;
    }
  }

  .caption {
    margin: 6px 0 0;
  }

  @media (max-width: ${breakpoints.phablet}px) {
    flex-flow: column;

    &.social-media {
      flex-flow: row wrap;

      .image-container {
        flex-basis: 30% !important;
      }
    }
  }
`

const Images = ({ ids, className = "", columns = "2", showTitle, urls }) => {
  const { allContentfulAsset } = useContext(ContentfulDataContext)

  const selectedImages = ids.split(",").map(imgId => {
    const matches = allContentfulAsset.edges.filter(({ node: image }) => {
      return imgId && imgId.indexOf(image.contentful_id) > -1
    })

    return matches && matches.length ? matches[0] : null
  })

  if (!selectedImages.length) {
    return ""
  }

  const urlArr = urls ? urls.split(",") : []

  const LinkContainer = ({ index, children }) => (
    <>
      {urlArr.length && urlArr[index] ? (
        <a href={urlArr[index]}>{children}</a>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </>
  )

  const flexClass = `images-${columns || 2}`

  return (
    <Container className={className}>
      {selectedImages.map((item, index) => {
        const image = item ? item.node : null

        return (
          <React.Fragment
            key={image ? `${image.contentful_id}-${index}` : index}
          >
            {image ? (
              <div className={`image-container ${flexClass}`}>
                <LinkContainer index={index}>
                  <Img
                    fluid={image.fluid}
                    alt={image.title}
                    title={image.description}
                  />
                </LinkContainer>
                {showTitle ? (
                  <p className="caption">{image.description}</p>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className={`image-container ${flexClass}`}></div>
            )}
          </React.Fragment>
        )
      })}
    </Container>
  )
}

export default Images
